var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{ref:"tree",attrs:{"default-checked-keys":_vm.value,"show-checkbox":_vm.checkbox,"node-key":_vm.treeProps.id||'id',"default-expand-all":false,"data":_vm.treeData,"props":_vm.treeProps,"expand-on-click-node":true,"filter-node-method":_vm.filterNode},on:{"check-change":_vm.checkChange,"node-click":_vm.nodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }